<script>
  import { redirect } from '@sveltech/routify';
  $redirect('/products');
</script>
